import { TableCell } from "@compass/core";
import { ReactNode } from "react";

type HighlightedCellProps = {
  children: ReactNode;
  from?: string;         
  bgColor?: string;       // customizable background color
};

export const HighlightedCell = ({
  children,
  bgColor = "#eff3ff",     
}: HighlightedCellProps) => {
  return (
      <TableCell
        sx={{
          backgroundColor: bgColor, 
        }}
      >
        {children}
      </TableCell>
  );
};